import React from 'react';
import { IPointOfSaleSettingsProps } from 'components/settings/PointOfSaleSettings';
import { SwitchFormField } from 'lib/form/fields/SwitchFormField';
import { TextFormField } from 'lib/form/fields/TextFormField';
import { SettingDisplay } from 'lib/SettingDisplay';

export const PowercardSettingsEdit: React.FC<IPointOfSaleSettingsProps> = ({ locationId }) => (
    <>
        {/* Common Only */}
        {locationId === undefined && (
            <>
                <SettingDisplay label="Production Environment">
                    <SwitchFormField name="powercardIsProduction" />
                </SettingDisplay>
                <SettingDisplay label="API Token">
                    <TextFormField name="powercardApiToken" />
                </SettingDisplay>
                <SettingDisplay label="Merchant ID">
                    <TextFormField name="powercardMerchantId" />
                </SettingDisplay>
            </>
        )}
        {/* Location Only */}
        {locationId !== undefined && (
            <SettingDisplay label="Location ID">
                <TextFormField name="powercardLocationId" />
            </SettingDisplay>
        )}
    </>
);
